import MainModel from "../../../../components/Models/main-model";
import { Box, FormLabel, Heading, VStack } from "@chakra-ui/react";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import Select from "react-select";
import { approveStudentRequest } from "../../../../modules/admin-modules/students/Actions";

const ApproveStudentModal = ({ isOpen, studentData, onClose }) => {
  const dispatch = useDispatch();
  const groups = useSelector((state) => state.groups.groups);
  const isLoading = useSelector((state) => state.students.isSuspend);
  const [selectedGroupId, setSelectedGroupId] = useState(null);

  const subjectId =
    studentData?.subject?.id || studentData?.group?.subject?.id;

  const filteredGroups = subjectId
    ? groups?.filter((group) => group?.subject?.id === subjectId)
    : groups;

  const groupsOptions = filteredGroups?.map((group) => ({
    value: group.id,
    label: group.name,
  }));

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  useEffect(() => {
    if (studentData) {
      setSelectedGroupId(studentData?.group?.id || null);
    }
  }, [studentData]);

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        الموافقة على الطالب
      </Heading>
    </Box>
  );

  const handleApprove = () => {
    if (!selectedGroupId) return;

    dispatch(
      approveStudentRequest({
        id: studentData?.id,
        student_group_id: selectedGroupId,
      })
    );
    onClose();
  };

  const closeFunc = () => {
    setSelectedGroupId(null);
    onClose();
  };

  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={isOpen}
      buttonTitle="تأكيد الموافقة"
      buttonFunc={handleApprove}
    >
      <VStack dir="rtl" spacing={4}>
        <FormLabel>الطالب: {studentData?.name}</FormLabel>
        <Box w="100%">
          <FormLabel>المجموعة الدراسية</FormLabel>
          <Select
            options={groupsOptions}
            value={
              groupsOptions?.find(
                (opt) => String(opt.value) === String(selectedGroupId)
              ) || null
            }
            onChange={(data) => setSelectedGroupId(data?.value || null)}
            styles={colourStyles}
            placeholder="اختر المجموعة"
          />
        </Box>
      </VStack>
    </MainModel>
  );
};

export default ApproveStudentModal;
